// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export let environment;

const host = window.location.host;

// Check if current domain is pentest
const isPentest = host.includes('pentest');

console.log('isPentest:', isPentest, host);

// Backend URLs
const apiEndPoint = isPentest
  ? 'https://allyhealth-back-pentest.theclientdemos.com/api/v3/'
  : 'https://allyhealth-back.theclientdemos.com/api/v3/';

const apiEndPointMDLive = isPentest
  ? 'https://allyhealth-back-pentest.theclientdemos.com/api/v3/mdlive/'
  : 'https://allyhealth-back.theclientdemos.com/api/v3/mdlive/';

if (window.location.host.includes('localhost') || window.location.host == '192.168.6.99:9200') {
  environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyD2XvC8J7qjhN_87GzeXHwk_TswENrgHGQ",
      authDomain: "call-a-doctor-plus.firebaseapp.com",
      projectId: "call-a-doctor-plus",
      storageBucket: "call-a-doctor-plus.firebasestorage.app",
      messagingSenderId: "318238464878",
      appId: "1:318238464878:web:834a441f06c1f1e7cf7f7f"
    },
    APIEndpoint: apiEndPoint,
    APIEndpointMDLive: apiEndPointMDLive
  };
}
else if (window.location.host.includes('benefitsnavigator')) {
  environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyAMDWIL6LOFS2bJcV-DzW5LEkhJff4h3Ws",
      authDomain: "benefits-navigator.firebaseapp.com",
      projectId: "benefits-navigator",
      storageBucket: "benefits-navigator.appspot.com",
      messagingSenderId: "863616485810",
      appId: "1:863616485810:web:c9ea90885aa10b7fa2bcab",
      measurementId: "G-BDGBYJEPDK"

    },
    APIEndpoint: apiEndPoint,
    lyricEndpoint: 'https://staging.getlyric.com/go/api',
    APIEndpointMDLive: apiEndPointMDLive
  };

}
else if (window.location.host.includes('allyhealth')) {
  environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyBKh7QUV5pyZqnm7QXM03UJTaxT1jtWnY4",
      authDomain: "allyhealth-6e47a.firebaseapp.com",
      databaseURL: "https://allyhealth-6e47a.firebaseio.com",
      projectId: "allyhealth-6e47a",
      storageBucket: "allyhealth-6e47a.appspot.com",
      messagingSenderId: "510679352793",
      appId: "1:510679352793:web:42758a23f7e69f0bb205c8"
    },
    APIEndpoint: apiEndPoint,
    lyricEndpoint: 'https://staging.getlyric.com/go/api',
    APIEndpointMDLive: apiEndPointMDLive
  };

}
else if (window.location.host.includes('cadrplus')) {
  environment = {
    production: false,
    firebase: {
      apiKey: "AIzaSyD2XvC8J7qjhN_87GzeXHwk_TswENrgHGQ",
      authDomain: "call-a-doctor-plus.firebaseapp.com",
      projectId: "call-a-doctor-plus",
      storageBucket: "call-a-doctor-plus.firebasestorage.app",
      messagingSenderId: "318238464878",
      appId: "1:318238464878:web:834a441f06c1f1e7cf7f7f"
    },
    APIEndpoint: apiEndPoint,
    APIEndpointMDLive: apiEndPointMDLive
  };
}

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.



